module.exports = __webpack_public_path__ + "static/media/mcelu.54d80b9c.jpg";